import _asyncToGenerator from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _createForOfIteratorHelper from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _toConsumableArray from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator/index.js";
import { getErrorMap } from "../errors.js";
import defaultErrorMap from "../locales/en.js";
export var makeIssue = function makeIssue(params) {
  var data = params.data,
      path = params.path,
      errorMaps = params.errorMaps,
      issueData = params.issueData;
  var fullPath = [].concat(_toConsumableArray(path), _toConsumableArray(issueData.path || []));

  var fullIssue = _objectSpread(_objectSpread({}, issueData), {}, {
    path: fullPath
  });

  if (issueData.message !== undefined) {
    return _objectSpread(_objectSpread({}, issueData), {}, {
      path: fullPath,
      message: issueData.message
    });
  }

  var errorMessage = "";
  var maps = errorMaps.filter(function (m) {
    return !!m;
  }).slice().reverse();

  var _iterator = _createForOfIteratorHelper(maps),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var map = _step.value;
      errorMessage = map(fullIssue, {
        data: data,
        defaultError: errorMessage
      }).message;
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return _objectSpread(_objectSpread({}, issueData), {}, {
    path: fullPath,
    message: errorMessage
  });
};
export var EMPTY_PATH = [];
export function addIssueToContext(ctx, issueData) {
  var overrideMap = getErrorMap();
  var issue = makeIssue({
    issueData: issueData,
    data: ctx.data,
    path: ctx.path,
    errorMaps: [ctx.common.contextualErrorMap, // contextual error map is first priority
    ctx.schemaErrorMap, // then schema-bound map if available
    overrideMap, // then global override map
    overrideMap === defaultErrorMap ? undefined : defaultErrorMap // then global default map
    ].filter(function (x) {
      return !!x;
    })
  });
  ctx.common.issues.push(issue);
}
export var ParseStatus = /*#__PURE__*/function () {
  function ParseStatus() {
    _classCallCheck(this, ParseStatus);

    this.value = "valid";
  }

  return _createClass(ParseStatus, [{
    key: "dirty",
    value: function dirty() {
      if (this.value === "valid") this.value = "dirty";
    }
  }, {
    key: "abort",
    value: function abort() {
      if (this.value !== "aborted") this.value = "aborted";
    }
  }], [{
    key: "mergeArray",
    value: function mergeArray(status, results) {
      var arrayValue = [];

      var _iterator2 = _createForOfIteratorHelper(results),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var s = _step2.value;
          if (s.status === "aborted") return INVALID;
          if (s.status === "dirty") status.dirty();
          arrayValue.push(s.value);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      return {
        status: status.value,
        value: arrayValue
      };
    }
  }, {
    key: "mergeObjectAsync",
    value: function () {
      var _mergeObjectAsync = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(status, pairs) {
        var syncPairs, _iterator3, _step3, pair, key, value;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              syncPairs = [];
              _iterator3 = _createForOfIteratorHelper(pairs);
              _context.prev = 2;

              _iterator3.s();

            case 4:
              if ((_step3 = _iterator3.n()).done) {
                _context.next = 15;
                break;
              }

              pair = _step3.value;
              _context.next = 8;
              return pair.key;

            case 8:
              key = _context.sent;
              _context.next = 11;
              return pair.value;

            case 11:
              value = _context.sent;
              syncPairs.push({
                key: key,
                value: value
              });

            case 13:
              _context.next = 4;
              break;

            case 15:
              _context.next = 20;
              break;

            case 17:
              _context.prev = 17;
              _context.t0 = _context["catch"](2);

              _iterator3.e(_context.t0);

            case 20:
              _context.prev = 20;

              _iterator3.f();

              return _context.finish(20);

            case 23:
              return _context.abrupt("return", ParseStatus.mergeObjectSync(status, syncPairs));

            case 24:
            case "end":
              return _context.stop();
          }
        }, _callee, null, [[2, 17, 20, 23]]);
      }));

      function mergeObjectAsync(_x, _x2) {
        return _mergeObjectAsync.apply(this, arguments);
      }

      return mergeObjectAsync;
    }()
  }, {
    key: "mergeObjectSync",
    value: function mergeObjectSync(status, pairs) {
      var finalObject = {};

      var _iterator4 = _createForOfIteratorHelper(pairs),
          _step4;

      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var pair = _step4.value;
          var key = pair.key,
              value = pair.value;
          if (key.status === "aborted") return INVALID;
          if (value.status === "aborted") return INVALID;
          if (key.status === "dirty") status.dirty();
          if (value.status === "dirty") status.dirty();

          if (key.value !== "__proto__" && (typeof value.value !== "undefined" || pair.alwaysSet)) {
            finalObject[key.value] = value.value;
          }
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }

      return {
        status: status.value,
        value: finalObject
      };
    }
  }]);
}();
export var INVALID = Object.freeze({
  status: "aborted"
});
export var DIRTY = function DIRTY(value) {
  return {
    status: "dirty",
    value: value
  };
};
export var OK = function OK(value) {
  return {
    status: "valid",
    value: value
  };
};
export var isAborted = function isAborted(x) {
  return x.status === "aborted";
};
export var isDirty = function isDirty(x) {
  return x.status === "dirty";
};
export var isValid = function isValid(x) {
  return x.status === "valid";
};
export var isAsync = function isAsync(x) {
  return typeof Promise !== "undefined" && x instanceof Promise;
};